$(function() {
    var $drawerChk = $('#drawerCheckbox');
    var $header = $('.header');
    var $headerH;
    var $main = $('.main');
    var $gNav = $header.find('.navColumns');

    /* -------------------------------------------------------------
     モバイル端末でアクセスした場合の処理
     ------------------------------------------------------------- */
    var isMobile;
    var mobileFunc = function(){
        if(isMobile){
            $('input[type=text].js__inputNumber').attr('type','number');
        }
    }
    if($('.gnavToggle__icon').is(':visible')!==false){
        isMobile = true;
    }
    mobileFunc();
    /* -------------------------------------------------------------
     モバイル・タブレット端末に切り替わった時の処理
     ------------------------------------------------------------- */
    var switchingToMobile = function() {
        $headerH = $header.outerHeight();
        $header.css({'position':'fixed'});
        $main.css({'margin-top':$headerH});
        $gNav.css({'padding-top':$headerH});
        $drawerChk.prop('checked',false);
    };
    /* -------------------------------------------------------------
     PCに切り替わった時の処理
     ------------------------------------------------------------- */
    var switchingToPC = function() {
        $headerH = $header.outerHeight();
        $header.css({'position':'fixed'});
        $main.css({'margin-top':$headerH});
        $gNav.css({'padding-top':$headerH});
        $drawerChk.prop('checked',false);
    };
    rwd.init();
    /* -------------------------------------------------------------
     レスポンシブ設定
     ------------------------------------------------------------- */
    if (rwd.supported) {
        rwd.register('(min-width: 0) and (max-width: 979px)', switchingToMobile);
        rwd.register('(min-width: 980px)', switchingToPC);
        rwd.update();
        $('.sectionBoard .table__rwd').responsiveTable({
            secondlyClassName: 'table__rwd--mobile'
        });
    } else {
        switchingToPC();
    }
});